export const colorOptions = {
  // Row 1
  '#ebe9e1': 'White', // Bright White (H-140)
  '#d7be88': 'Coffee Cream', // Light Sand (H-142)
  '#d5b173': 'Brass', // Brass (3)
  '#9c9e9e': 'Satin Aluminum', // Raw Sandblast (33)
  '#645648': 'Smoked Bronze', // Smoked Bronze (H-359)
  '#1c1d1d': 'Black', // Graphite Black (1)

  // Row 2
  '#975b3a': 'Terracotta', // Copper Suede (H-310)
  '#a16f48': 'Copper', // Copper (H-347)
  '#d8763c': 'Burnt Orange', // Tequila Sunrise (H-309)
  '#ce984c': 'Gold', // Gold (H-122)
  '#d4a53a': 'Sunflower', // Sunglow Yellow (H-144)
  '#ffca0d': 'Formula Yellow', // Sunflower (H-317)

  // Row 3
  '#a4402c': 'Calabrian Red', // Habanero Red (H-318)
  '#5e2833': 'Spiced Berry', // Blood Orange (H-322)
  '#802641': 'Dark Fuchsia', // Sangria (H-348)
  '#56475e': 'Vera Violet', // Bright Purple (H-217)
  '#926464': 'Rose Gold', // Rose Gold (H-197)
  '#c68883': 'Petal Pink', // Bazooka Pink (H-327)

  // Row 4
  '#79712f': 'Mosslight Green', // MultiCam Light Green (H-340)
  '#5e6d35': 'Verdant Green', // MultiCam Bright Green (H-343)
  '#394a37': 'Evergreen', // Jesse James Eastern Front Green (H-400)
  '#344e4a': 'Meridian Blue', // Jesse James Civil Defense Blue (H-401)
  '#196962': 'Turquoise Teal', // Aztec Teal (H-349)
  '#4db494': 'Aqua Lucia' // Robin's Egg Blue (H-175)
}

export const screenColorOptions = {
  '#ebe9e1': 'White', // Bright White (H-140)
  '#d7be88': 'Coffee Cream', // Light Sand (H-142)
  '#d5b173': 'Brass', // Brass (3)
  'Stainless Steel': 'Stainless (Brushed)',
  '#645648': 'Smoked Bronze', // Smoked Bronze (H-359)
  '#1c1d1d': 'Black', // Graphite Black (1)

  // Row 2
  '#975b3a': 'Terracotta', // Copper Suede (H-310)
  '#a16f48': 'Copper', // Copper (H-347)
  '#d8763c': 'Burnt Orange', // Tequila Sunrise (H-309)
  '#ce984c': 'Gold', // Gold (H-122)
  '#d4a53a': 'Sunflower', // Sunglow Yellow (H-144)
  '#ffca0d': 'Formula Yellow', // Sunflower (H-317)

  // Row 3
  '#a4402c': 'Calabrian Red', // Habanero Red (H-318)
  '#5e2833': 'Spiced Berry', // Blood Orange (H-322)
  '#802641': 'Dark Fuchsia', // Sangria (H-348)
  '#56475e': 'Vera Violet', // Bright Purple (H-217)
  '#926464': 'Rose Gold', // Rose Gold (H-197)
  '#c68883': 'Petal Pink', // Bazooka Pink (H-327)

  // Row 4
  '#79712f': 'Mosslight Green', // MultiCam Light Green (H-340)
  '#5e6d35': 'Verdant Green', // MultiCam Bright Green (H-343)
  '#394a37': 'Evergreen', // Jesse James Eastern Front Green (H-400)
  '#344e4a': 'Meridian Blue', // Jesse James Civil Defense Blue (H-401)
  '#196962': 'Turquoise Teal', // Aztec Teal (H-349)
  '#4db494': 'Aqua Lucia' // Robin's Egg Blue (H-175)
}

export const fabricColorOptions = {
  '#FFFFFF': 'White',
  '#1a1a1a': 'Black'
  // Add more mappings as needed
}

export const bottomfabricColorOptions = {
  '#FFFFFF': 'White',
  '#1a1a1a': 'Black',
  '#PRIDE': 'Pride',
  none: 'No Fill'
  // Add more mappings as needed
}

// Color descriptions and swatch URLs
export const colorDescriptions = {
  '#ebe9e1': {
    name: 'White',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/1-White.webp',
    cerakoteCode: 'H-140',
    description: 'Mineral white with a faint gray cast, quietly sentient without piercing.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_White.webp',
    portraits: [
      { bodyColor: 'White', screenColor: 'White', imageUrl: '' },
      { bodyColor: 'White', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'White', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#d7be88': {
    name: 'Coffee Cream',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/2-Coffee_Cream.webp',
    cerakoteCode: 'H-142',
    description: 'Warm ivory with depth, like coffee settling into cream. It feels like lived-in light, four sips into the morning.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Coffee-Cream.webp',
    portraits: [
      { bodyColor: 'Coffee Cream', screenColor: 'Coffee Cream', imageUrl: '' },
      { bodyColor: 'Coffee Cream', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Coffee Cream', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#d5b173': {
    name: 'Brass',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/3-Brass.webp',
    description:
      'Hefty and sovereign pure brass, hand polished and clear sealed against time. It signals gravity on sight and confirms it the moment the weight settles into your hands.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Brass.webp',
    isPremium: true,
    premiumPrice: 499,
    portraits: [
      { bodyColor: 'Brass', screenColor: 'Brass', imageUrl: '' },
      { bodyColor: 'Brass', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Brass', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  'Stainless Steel': {
    name: 'Stainless Steel',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/25-Stainless_Steel.webp',
    description: 'Raw stainless, hand polished to a soft, controlled sheen. Precise, minimal, and grounded in the material itself.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260330_Swatches_Stainless-Steel.webp',
    portraits: [
      { bodyColor: 'Stainless Steel', screenColor: 'Stainless Steel', imageUrl: '' },
      { bodyColor: 'Stainless Steel', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Stainless Steel', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#9c9e9e': {
    name: 'Satin Aluminum',
    cerakoteCode: 'H-151',
    description: 'Hand sandblasted to reveal its industrial grain, then clear sealed. Matte, controlled, deliberate.',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/4-Satin_Alluminum.webp',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Satin-Alluminum.webp',
    portraits: [
      { bodyColor: 'Satin Aluminum', screenColor: 'Satin Aluminum', imageUrl: '' },
      { bodyColor: 'Satin Aluminum', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Satin Aluminum', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#645648': {
    name: 'Smoked Bronze',
    cerakoteCode: 'H-359',
    description: 'Deep, flecked bronze softened to a velveteen espresso finish. Warmth under restraint, light absorbed rather than reflected.',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/5-Smoked_Bronze.webp',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Smoked-Bronze.webp',
    portraits: [
      { bodyColor: 'Smoked Bronze', screenColor: 'Smoked Bronze', imageUrl: '' },
      { bodyColor: 'Smoked Bronze', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Smoked Bronze', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#1c1d1d': {
    name: 'Black',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/6-Black.webp',
    cerakoteCode: 'F-102',
    description: 'The most enduring shade. Crisp and satin, exact in its presence. The ceramic coating is so crisp it reads as refinement, not paint.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Graphite-Black.webp',
    portraits: [
      { bodyColor: 'Black', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Black', screenColor: 'White', imageUrl: '' },
      { bodyColor: 'Black', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#975b3a': {
    name: 'Terracotta',
    cerakoteCode: 'H-310',
    description: 'Rich orange-brown metallic with a fine, warm shimmer. An old village skyline at golden hour, tomato vines trailing from sun-warmed clay.',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/7-Terracotta.webp',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Terracotta.webp',
    portraits: [
      { bodyColor: 'Terracotta', screenColor: 'Terracotta', imageUrl: '' },
      { bodyColor: 'Terracotta', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Terracotta', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#a16f48': {
    name: 'Copper',
    cerakoteCode: 'H-347',
    description:
      'True copper metallic with ember-fine shimmer. It feels discovered in a forgotten apothecary drawer, woodsy and warm, just dramatic enough to know it.',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/8-Copper.webp',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Copper.webp',
    portraits: [
      { bodyColor: 'Copper', screenColor: 'Copper', imageUrl: '' },
      { bodyColor: 'Copper', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Copper', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#d8763c': {
    name: 'Burnt Orange',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/9-Burnt_Orange.webp',
    cerakoteCode: 'H-309',
    description:
      'Saturated orange laced with fine metallic fleck. The ghost-whip of flame, the seared inhale of a Mojave sunset as the sun crests behind the hills.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Burnt-Orange.webp',
    portraits: [
      { bodyColor: 'Burnt Orange', screenColor: 'Burnt Orange', imageUrl: '' },
      { bodyColor: 'Burnt Orange', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Burnt Orange', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#ce984c': {
    name: 'Gold',
    cerakoteCode: 'H-122',
    description:
      'Gold metallic with an even, fine shimmer. Quietly established, its shine held in check, the kind of gold that belongs to a house with a crest.',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/10-Gold.webp',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Gold.webp',
    portraits: [
      { bodyColor: 'Gold', screenColor: 'Gold', imageUrl: '' },
      { bodyColor: 'Gold', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Gold', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#d4a53a': {
    name: 'Sunflower',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/11-Sunflower.webp',
    cerakoteCode: 'H-144',
    description: 'A green-tinged yellow warmed toward goldenrod. As if enclosed within tall stalks, looking up through foliage into sunlit petals.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Sunflower.webp',
    portraits: [
      { bodyColor: 'Sunflower', screenColor: 'Sunflower', imageUrl: '' },
      { bodyColor: 'Sunflower', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Sunflower', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#ffca0d': {
    name: 'Formula Yellow',
    cerakoteCode: 'H-317',
    description: 'High-gloss yellow with asphalt heat beneath it. Rally-ready and sharp on contact, the kind of yellow that feels fast even standing still.',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/12_Formula_Yellow.webp',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Formula-Yellow.webp',
    portraits: [
      { bodyColor: 'Formula Yellow', screenColor: 'Formula Yellow', imageUrl: '' },
      { bodyColor: 'Formula Yellow', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Formula Yellow', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#a4402c': {
    name: 'Calabrian Red',
    cerakoteCode: 'H-318',
    description: 'Chili red with restrained metallic detail. Garnet-deep and sun-cured, a heat that lingers close before settling into the skin.',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/13-Calabrian_Red.webp',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Calabrian-Red.webp',
    portraits: [
      { bodyColor: 'Calabrian Red', screenColor: 'Calabrian Red', imageUrl: '' },
      { bodyColor: 'Calabrian Red', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Calabrian Red', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#5e2833': {
    name: 'Spiced Berry',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/14-Spiced_Berry.webp',
    cerakoteCode: 'H-322',
    description: 'An elegant deep, rich metallic cranberry color with a hint of a warm shimmer.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Spiced-Berry.webp',
    portraits: [
      { bodyColor: 'Spiced Berry', screenColor: 'Spiced Berry', imageUrl: '' },
      { bodyColor: 'Spiced Berry', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Spiced Berry', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#802641': {
    name: 'Dark Fuchsia',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/15-Dark-Fuchsia.webp',
    cerakoteCode: 'H-348',
    description:
      'A deep fuchsia that resists both pink and purple. Nocturnal in mood, it recalls heavy amaranth blooms, bright at the surface, though depth stays composed.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Dark-Fuchsia.webp',
    portraits: [
      { bodyColor: 'Dark Fuchsia', screenColor: 'Dark Fuchsia', imageUrl: '' },
      { bodyColor: 'Dark Fuchsia', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Dark Fuchsia', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#56475e': {
    name: 'Vera Violet',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/16-Vera_Violet.webp',
    cerakoteCode: 'H-217',
    description:
      'The essential purple, saturated with dream and depth, like a galaxy rendered fully when the gamma ripens the flavor of its light. Named for Vera Rubin, whose dark matter work reshaped our map of the unseen universe.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Vera-Violet.webp',
    portraits: [
      { bodyColor: 'Vera Violet', screenColor: 'Vera Violet', imageUrl: '' },
      { bodyColor: 'Vera Violet', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Vera Violet', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#926464': {
    name: 'Rose Gold',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/17-Rose_Gold.webp',
    cerakoteCode: 'H-197',
    description:
      'A warm pink tempered with soft gold and metallic light. As if pink locked in, did the work, and came back with its PhD, grounded and unmistakably sure of itself.',
    circleSwatchUrl:
      'https://cdn.shopify.com/s/files/1/0564/1820/5796/files/rose-gold-circle-h-327-thumbnail_a348bb62-2704-4495-8602-430d4587319a.png?v=1770848734',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Rose-Gold.webp',
    portraits: [
      { bodyColor: 'Rose Gold', screenColor: 'Rose Gold', imageUrl: '' },
      { bodyColor: 'Rose Gold', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Rose Gold', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#c68883': {
    name: 'Petal Pink',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/18-Petal_Pink.webp',
    cerakoteCode: 'H-327',
    description: 'A soft, confectioned pink with a quiet floral undertone, nearly chewable, the kind of color that feels individually wrapped.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Petal-Pink.webp',
    portraits: [
      { bodyColor: 'Petal Pink', screenColor: 'Petal Pink', imageUrl: '' },
      { bodyColor: 'Petal Pink', screenColor: 'White', imageUrl: '' },
      { bodyColor: 'Petal Pink', screenColor: 'Black', imageUrl: '' }
    ]
  },
  '#79712f': {
    name: 'Mosslight Green',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/19-Mosslight_Green.webp',
    cerakoteCode: 'H-340',
    description: 'An olive-leaning green with a warm oxide base. Like moss beds absorbing filtered light beneath a forest canopy.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Mosslight-Green.webp',
    portraits: [
      { bodyColor: 'Mosslight Green', screenColor: 'Mosslight Green', imageUrl: '' },
      { bodyColor: 'Mosslight Green', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Mosslight Green', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#5e6d35': {
    name: 'Verdant Green',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/20-Verdant_Green.webp',
    cerakoteCode: 'H-343',
    description: 'A muted mid-green with a warm yellow base, chlorophyll returning light in its richest register.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Verdant-Green.webp',
    portraits: [
      { bodyColor: 'Verdant Green', screenColor: 'Verdant Green', imageUrl: '' },
      { bodyColor: 'Verdant Green', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Verdant Green', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#394a37': {
    name: 'Evergreen',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/21-Evergreen.webp',
    cerakoteCode: 'H-400',
    description: 'A dense green, cool at its core, spanning conifer tree heights and kelp grove depths, ever the same across two forests.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Evergreen.webp',
    portraits: [
      { bodyColor: 'Evergreen', screenColor: 'Evergreen', imageUrl: '' },
      { bodyColor: 'Evergreen', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Evergreen', screenColor: 'Coffee Cream', imageUrl: '' }
    ]
  },
  '#344e4a': {
    name: 'Meridian Blue',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/22-Meridian_Blue.webp',
    cerakoteCode: 'H-401',
    description: 'A flat, balanced blue with a green cast, filling the map where waters remain unsounded.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Meridian-Blue.webp',
    portraits: [
      { bodyColor: 'Meridian Blue', screenColor: 'Meridian Blue', imageUrl: '' },
      { bodyColor: 'Meridian Blue', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Meridian Blue', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#196962': {
    name: 'Turquoise Teal',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/23-Turquoise_Teal.webp',
    cerakoteCode: 'H-349',
    description: 'This turquoise-teal holds a contained vitality, its color alive while the finish stays matte and controlled. A standard in the Ohma palette.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Turquoise-Teal.webp',
    portraits: [
      { bodyColor: 'Turquoise Teal', screenColor: 'Turquoise Teal', imageUrl: '' },
      { bodyColor: 'Turquoise Teal', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Turquoise Teal', screenColor: 'White', imageUrl: '' }
    ]
  },
  '#4db494': {
    name: 'Aqua Lucia',
    circleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/24-Aqua_Lucia.webp',
    cerakoteCode: 'H-175',
    description: 'A blue leaning toward green, clear and light-bearing, its brightness softened at the surface, like warm island water gathered in a tidepool.',
    rectangleSwatchUrl: 'https://pub-e2a1a41ee7e84eefbab9b339c21acfb0.r2.dev/260317_Swatches_Aqua-Lucia.webp',
    portraits: [
      { bodyColor: 'Aqua Lucia', screenColor: 'Aqua Lucia', imageUrl: '' },
      { bodyColor: 'Aqua Lucia', screenColor: 'Black', imageUrl: '' },
      { bodyColor: 'Aqua Lucia', screenColor: 'White', imageUrl: '' }
    ]
  }
}

export const options = {
  screenType: {
    Motif: 'MOT',
    Scales: 'SCA',
    Stripes: 'STR',
    Windows: 'WIN',
    Holes: 'HOL'
  },
  micType: {
    Ribbon: 'R',
    Condenser: 'C'
  },
  logoType: {
    Logo: 'L',
    'Add Pattern Screen': 'P',
    'Custom Logo': 'C'
  },
  colors: {
    White: 0,
    Black: 1,
    'Stainless Steel': 2,
    Brass: 3,
    'Turquoise Teal': 4,
    'Coffee Cream': 9,
    Terracotta: 10,
    'Burnt Orange': 11,
    Gold: 13,
    'Petal Pink': 15,
    'Rose Gold': 19,
    Sunflower: 21,
    'Satin Aluminum': 33,
    Sangria: 64,
    'Smoked Bronze': 100,
    Copper: 101,
    'Sunglow Yellow': 102,
    'Blood Orange': 103,
    'Habanero Red': 104,
    'Iris Purple': 105,
    'Mosslight Green': 106,
    'Field Green': 107,
    Evergreen: 108,
    'Harbor Blue': 109,
    'Aqua Lucia': 110,
    'Spiced Berry': 111
  }
}
